import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  header: {
    width: '100%',
    height: '100%',
    padding: '10px 0 50px 0',
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',
    alignItems: 'center',
    '@media (max-width: 768px)': {
      padding: '20px 0 30px 0',
    },
  },
  appTitle: {
    fontSize: '2.8625em',
    color: theme.palette.primary.main,
    paddingBottom: 0,
    marginBottom: 10,
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.5rem',
    },
  },
  linkQlik: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: -20,
    right: 10,
    color: '#16A054',
    fontWeight: 600,
    [theme.breakpoints.down('xs')]: {
      fontSize: '.8rem',
      flexDirection: 'column',
      textAlign: 'right',
      top: -30,
      right: 0,
    },
  },
  linkQlikText: {
    paddingRight: 5,
    [theme.breakpoints.down('xs')]: {
      paddingRight: 0,
    },
  },
  logoQlikAnalytics: {
    width: 100,
    height: 'auto',
    '@media (max-width: 768px)': {
      width: 80,
    },
  },
}));

export default useStyles;
